"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpandTypeArray = exports.isResponseType = exports.isExpandType = exports.isGenericDataRowArray = exports.isGenericDataRow = exports.isDataPoint = exports.isRequest = exports.isPromise = exports.isRequestHeaders = exports.isAvatarSizes = exports.isDataFormatTypes = exports.isRequestMethods = exports.isInEnum = exports.isDate = exports.isFormData = exports.isFile = exports.isBoolean = exports.isFunction = exports.isArray = exports.isNumber = exports.isString = exports.isUndefined = void 0;
var tg = __importStar(require("generic-type-guard"));
var models_1 = require("src/models");
/**
 * Custom Type Guards
 *
 * @private
 * */
exports.isUndefined = tg.isUndefined;
exports.isString = tg.isString;
exports.isNumber = tg.isNumber;
exports.isArray = tg.isArray(tg.isUnknown);
/* eslint-disable-next-line @typescript-eslint/ban-types */
function isFunction(arg) {
    return typeof arg === 'function';
}
exports.isFunction = isFunction;
exports.isBoolean = tg.isBoolean;
function isFile(arg) {
    return arg instanceof File;
}
exports.isFile = isFile;
function isFormData(arg) {
    return arg instanceof FormData;
}
exports.isFormData = isFormData;
function isDate(arg) {
    // see https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date
    return (Object.prototype.toString.call(arg) === '[object Date]' &&
        isFinite(arg.getTime()));
}
exports.isDate = isDate;
function isInEnum(arg, enumObj) {
    return ((0, exports.isString)(arg) &&
        Object.keys(enumObj)
            .map(function (x) { return enumObj[x]; })
            .indexOf(arg) !== -1);
}
exports.isInEnum = isInEnum;
function isRequestMethods(arg) {
    return isInEnum(arg, models_1.RequestMethods);
}
exports.isRequestMethods = isRequestMethods;
function isDataFormatTypes(arg) {
    return isInEnum(arg, models_1.DataFormatTypes);
}
exports.isDataFormatTypes = isDataFormatTypes;
function isAvatarSizes(arg) {
    return isInEnum(arg, models_1.AvatarSizes);
}
exports.isAvatarSizes = isAvatarSizes;
exports.isRequestHeaders = new tg.IsInterface()
    .withProperty('accept', isDataFormatTypes)
    .withProperty('content-type', tg.isOptional(tg.isString))
    .withStringIndexSignature(tg.isOptional(tg.isString))
    .get();
exports.isPromise = new tg.IsInterface()
    .withProperty('then', isFunction)
    // see https://promisesaplus.com/#point-53
    .get();
exports.isRequest = new tg.IsInterface()
    .withProperty('url', tg.isString)
    .withProperty('method', isRequestMethods)
    .withProperty('params', tg.isOptional(tg.isString))
    .withProperty('headers', tg.isOptional(exports.isRequestHeaders))
    .withProperty('data', tg.isOptional(tg.isUnion(tg.isString, tg.isUnion(isFile, isFormData))))
    .withProperty('timeout', tg.isOptional(tg.isUnion(tg.isFiniteNumber, exports.isPromise)))
    .get();
exports.isDataPoint = new tg.UnionOf(tg.isString)
    .with(tg.isNumber)
    .with(tg.isNull)
    .get();
exports.isGenericDataRow = new tg.IsInterface().withStringIndexSignature(exports.isDataPoint).get();
exports.isGenericDataRowArray = tg.isArray(exports.isGenericDataRow);
function isExpandType(arg) {
    return isInEnum(arg, models_1.ExpandType);
}
exports.isExpandType = isExpandType;
function isResponseType(arg) {
    return isInEnum(arg, models_1.ResponseType);
}
exports.isResponseType = isResponseType;
exports.isExpandTypeArray = tg.isArray(isExpandType);
